import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { FileRes } from 'types/api/fileRes';

import { useIsAuthenticated } from '../auth/useIsAuthenticated';

type UsePageStorageReturn = {
    findFile: (uuid: string) => FileRes | undefined;
};

export const usePageStorage = (
    id?: string | number | null
): UsePageStorageReturn => {
    const { authChecked, authenticated } = useIsAuthenticated();

    const admin = authChecked && authenticated;

    const fetchFiles = useCallback(
        (): Promise<FileRes[]> =>
            axios
                .get(
                    admin
                        ? `/api/builder/page/${id}/storage/`
                        : `/api/page/${id}/storage/`
                )
                .then((response) => response.data),
        [admin, id]
    );

    const { data } = useQuery(['files'], fetchFiles, {
        refetchOnWindowFocus: false,
        enabled: !!id && authChecked,
    });

    const findFile = useCallback(
        (uuid: string): FileRes | undefined => {
            return data?.find((el) => el.uuid === uuid);
        },
        [data]
    );

    return { findFile };
};
